module.exports = __webpack_public_path__ + "static/media/img2.699efbcd.png";